// import csv from "papaparse";
// let data = [];
// let response = [];
// const csvFile = {
//     isValideCSV: async function(file,isValidateGreatedValue) {
//         response.splice(0, response.length);
//         data.splice(0, data.length);
//         return new Promise((resolve, reject) => {
//             let index = 1;
//             return csv.parse(file, {
//                 worker: true,
//                 step: function(results) {
//                     if (
//                         results.data[0] !== "Hour"
//                     ) {
//                         data.push({
//                             hour: index++,
//                             value: results.data[0],
//                         });
//                     }
//                 },
//                 complete: function() {
//                     return resolve(csvFile.validateData(isValidateGreatedValue));
//                 },
//                 error: (error) => {
//                     return reject(error);
//                 },
//             });
//         });
//     },

//     validateData: function(isValidateGreatedValue) {
//         response.splice(0, response.length);
//         let negativeValue = "";
//         let EmptyVal = "";
//         let notNumber = "";
//        if(isValidateGreatedValue){
//         negativeValue = data.filter((d) =>d.value > 9999  && d.value != "");
//        }
//        else
//        {
//         negativeValue = data.filter((d) => d.value <= 0  && d.value != "");
//        }

//         EmptyVal = data.filter((d) => d.value === null || d.value === "");
//         notNumber = data.filter((d) => !Number(d.value));
//         if (data.length < 8761) {
//             const res = {
//                 data: "",
//                 status: false,
//                 message: "File less than 8760 Rows",
//             };
//             response.push(res);
//         }
//         if (data.length > 8761) {
//             const res = {
//                 data: "",
//                 status: false,
//                 message: "File greater than 8761 Rows",
//             };
//             response.push(res);
//         }

//         if (negativeValue.length > 1) {
//             let message = "";
//             negativeValue.forEach((item) => {
//               if(item.hour < 8761){
//                 message =
//                     message + `value:${item.value} at the row of ${item.hour},`;
//               }
//             });

//             const res = {
//                 data: negativeValue,
//                 status: false,
//                 message: `Zero or negative value found in Electric Load kW. details:- ${message}`,
//             };
//             response.push(res);
//         }
//         if (EmptyVal.length > 1) {
//             let message = "";
//             EmptyVal.forEach((item) => {
//               if(item.hour < 8761){
//                 message = message + ` at the row of ${item.hour},`;
//               }

//             });
//             const res = {
//                 data: EmptyVal,
//                 status: false,
//                 message: ` Empty or Null value Found ${message}`,
//             };
//             response.push(res);
//         }

//         if (notNumber.length > 1) {
//             let message = "";
//             notNumber.forEach((item) => {
//               if(item.hour < 8761){
//                 message = message + ` at the row of ${item.hour},`;
//               }
//             });
//             const res = {
//                 data: notNumber,
//                 status: false,
//                 message: ` String value Found ${message}`,
//             };
//             response.push(res);
//         }

//         if (
//             EmptyVal.length === 1 &&
//             negativeValue.length === 1 &&
//             data.length === 8769 &&
//             notNumber.length === 1
//         ) {
//             const res = {
//                 data: "",
//                 status: true,
//                 message: "Validated successfully!",
//             };
//             response.push(res);
//         }

//         data.splice(0, data.length);
//         let result = "";
//         response.forEach((item) => {
//             result = result + item.message + ", ";
//         });

//         return result;
//     },
// };
// export default csvFile;

import _ from "lodash";
import csv from "papaparse";
let callCount = 0;
let data = [];
var monthsArray = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
];

let response = [];
let fileName = "";
const csvFile = {
    isValideCSV: async function(file, isValidateGreatedValue) {
        fileName = "";
        fileName = file.name;
        console.log("File Name ",file.name);
        response.splice(0, response.length);
        data.splice(0, data.length);

        return new Promise((resolve, reject) => {
            let index = 1;
            return csv.parse(file, {
                worker: true,
                step: function(results) {
                    if (
                        results.data[0] !== "date" ||
                        results.data[1] !== "value"
                    ) {
                        const MMStr = results.data[0];
                        // const MM = MMStr.substring(2, 5);
                        // const MMNumber = monthsArray.indexOf(MM.toLowerCase());
                        // const DD = MMStr.substring(0, 2);

                        const MMNumber = MMStr.substring(3, 5);
                        const DD = MMStr.substring(0, 2);
                        const hh = MMStr.substring(11, 13);
                        const mm = MMStr.substring(14, 16);

                        // console.log(results.data[1]);
                        // console.log(typeof(results.data[1]));


                        data.push({
                            id: index++,
                            date: Number(DD),
                            month: Number(MMNumber),
                            hour : Number(hh),
                            min : Number(mm),
                            value: Number(results.data[1]),
                        });
                        
                    }
                },
                complete: function() {
                    return resolve(
                        csvFile.validateData(isValidateGreatedValue)
                    );
                },
                error: (error) => {
                    return reject(error);
                },
            });
        });
    },
    sortDataByMMDD: function() {
        console.log("Old data ",data);
        const newData = _.orderBy(data, ["month", "date", "hour", "min"], ["asc", "asc", "asc", "asc"]);
        console.log("New data ",newData);
        return newData;
    },

    jsonTOCSV: function(dataObject) {
        console.log("Test")
        console.log(dataObject)
        const option = {
            quotes: false, 
            quoteChar: '"',
            escapeChar: '"',
            delimiter: "",
            header: false,
            newline: "\r\n",
            skipEmptyLines: false,
        };

        let finalata = [];
        dataObject.forEach((item) => {
            if (item.value) {
                finalata.push({
                    value: item.value,
                });
            }
        });
        var _csv = csv.unparse(finalata, option);
        var csvData = new Blob([_csv], { type: "text/csv;charset=utf-8;" });
        const file = new File([csvData], `${fileName}_finalFile`);
        return file;
    },

    validateData: function(isValidateGreatedValue) {
        const _data = this.sortDataByMMDD();
        response.splice(0, response.length);
        let negativeValue = "";
        let EmptyVal = "";
        let notNumber = "";
        let greaterValue = "";
        if (isValidateGreatedValue) {
            greaterValue = _data.filter((d) => d.value > 9999 && d.value != "");
        }

        negativeValue = _data.filter((d) => d.value <= 0 && d.value != "");
        EmptyVal = _data.filter((d) => d.value === null || d.value === "");
        notNumber = _data.filter((d) => !Number(d.value) && d.id < 8761);

        if (_data.length < 8760) {
            const res = {
                data: "",
                status: false,
                message: "File less than 8760 Rows",
            };
            response.push(res);
        }
        if (_data.length > 8761) {
            const res = {
                data: "",
                status: false,
                message: "File greater than 8761 Rows",
            };
            response.push(res);
        }

        if (greaterValue.length > 0) {
            let message = "";
            greaterValue.forEach((item) => {
                message =
                    message + `value:${item.value} at the row of ${item.id},`;
            });

            const res = {
                data: greaterValue,
                status: false,
                message: `Greater than 9999 value found in Electric Load kW. details:- ${message}`,
            };
            response.push(res);
        }

        if (negativeValue.length > 0) {
            let message = "";
            negativeValue.forEach((item) => {
                if (item.id <= 8760) {
                    message =
                        message +
                        `value:${item.value} at the row of ${item.id},`;
                }
            });

            const res = {
                data: negativeValue,
                status: false,
                message: `Zero or negative value found in Electric Load kW. details:- ${message}`,
            };
            response.push(res);
        }
        if (EmptyVal.length > 0) {
            let message = "";
            EmptyVal.forEach((item) => {
                if (item.id < 8761) {
                    message = message + ` at the row of ${item.id},`;
                }
            });
            const res = {
                data: EmptyVal,
                status: false,
                message: ` Empty or Null value Found ${message}`,
            };
            response.push(res);
        }

        if (notNumber.length > 0) {
            let message = "";
            notNumber.forEach((item) => {
                if (item.id < 8761) {
                    message = message + ` at the row of ${item.id},`;
                }
            });
            const res = {
                data: notNumber,
                status: false,
                message: ` String value Found ${message}`,
            };
            response.push(res);
        }

        console.log(EmptyVal.length);
        console.log(negativeValue.length);
        console.log(_data.length);
        console.log(notNumber.length);

        if (
            EmptyVal.length === 0 &&
            negativeValue.length === 0 &&
            _data.length === 8761 &&
            notNumber.length === 0
        ) {
            console.log("Boooommmmm")
            var csvFile = this.jsonTOCSV(_data);
            const res = {
                data: [csvFile],
                status: true,
                message: "Validated successfully!",
            };
            return res;
        } else {
            data.splice(0, data.length);
            let result = "";
            response.forEach((item) => {
                result = result + item.message + ", ";
            });
            const _res = {
                data: "",
                status: false,
                message: result,
            };

            console.log(_res);

            return _res;
        }
    },
};
export default csvFile;
